module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "p2222"
  }, [_c('div', {
    staticClass: "tl"
  }, [_vm._v("\n      " + _vm._s(_vm.val) + "\n    ")]), _vm._v(" "), _c('bo-input', {
    ref: "test",
    attrs: {
      "holder": "请输入内容",
      "required": true,
      "size": "lg",
      "focus": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p1000 tl"
  }, [_c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": _vm.getValue
    }
  }, [_vm._v("获取输入值")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": function($event) {
        _vm.setState('wrong')
      }
    }
  }, [_vm._v("置为警告")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": function($event) {
        _vm.setState('pass')
      }
    }
  }, [_vm._v("置为通过")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": _vm.verify
    }
  }, [_vm._v("验证")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row p2222"
  }, [_c('bo-input', {
    attrs: {
      "holder": "Large Size",
      "size": "lg",
      "icon": "scan"
    }
  }), _vm._v(" "), _c('bo-input', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "holder": "请输入内容",
      "size": "lg",
      "state": "wrong",
      "value": "一段内容"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row p1010"
  }, [_c('bo-input', {
    attrs: {
      "holder": "请输入内容",
      "size": "lg",
      "theme": "underline"
    }
  }), _vm._v(" "), _c('bo-input', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "holder": "请输入内容",
      "state": "pass",
      "size": "lg",
      "theme": "underline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row p2000"
  }, [_c('bo-input', {
    attrs: {
      "holder": "请输入内容",
      "label": "账 号",
      "theme": "blank",
      "size": "lg"
    }
  }), _vm._v(" "), _c('bo-input', {
    attrs: {
      "holder": "请输入内容",
      "label": "密 码",
      "theme": "blank",
      "size": "lg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row p2000"
  }, [_c('bo-input', {
    attrs: {
      "holder": "请输入内容",
      "label": "账 号",
      "theme": "head",
      "size": "lg"
    }
  }), _vm._v(" "), _c('bo-input', {
    attrs: {
      "holder": "请输入内容",
      "label": "密 码",
      "theme": "head",
      "size": "lg"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55f6b04e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-input/demo.vue
// module id = 251
// module chunks = 0